export function getTranslate(config) {
    return (key) => config[key] || key;
}
